wbApp.controller('ContractsOpzPlusParamsCtrl', ['$scope', '$q', '$translate', 'groupSvc',
    function ($scope, $q, $translate, groupSvc) {
        $scope.isSaving = false;
        
        $scope.model = {
            fromDate: moment().toDate(),
            toDate: moment().toDate(),
            groupId: null
        };
        $scope.modelOrig = angular.copy($scope.model);

        $scope.groups = groupSvc.getAllAsync();

        $scope.detailIsUnchanged = function (data) {
            return angular.equals(data, $scope.modelOrig);
        };

        $scope.onDetailSave = function (model) {
            $scope.$hide();
            let fromDate = moment(model.fromDate).startOf('day').toDate();
            let toDate = moment(model.toDate).endOf('day').toDate();
            window.open("restapi/contracts/exports/opzplus?fromDate=" + fromDate.toJSON() + "&toDate=" + toDate.toJSON() + "&groupId=" + model.groupId, '_blank');
        };

    }]);

